(function () {
  const form = document.currentScript.closest('form[role="search"]');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    const input = form.querySelector('input[name="q"]');
    if (!input) return;

    const query = input.value.trim();
    if (!query) return;

    e.preventDefault();

    const action = form.action;
    const separator = action.includes('?') ? '&' : '?';

    const typeInput = form.querySelector('input[name="type"]');
    const type = typeInput ? '&type=' + encodeURIComponent(typeInput.value) : '';

    window.location.href =
      action +
      separator +
      'q=' +
      encodeURIComponent(query + ' -tag:free') +
      type +
      '&options[prefix]=last';
  });
})();
